export default __webpack_public_path__ + "static/media/logo.e4140e67.svg";